module.exports = __webpack_public_path__ + "files/3e640fffca46b541d8aca145dd99e102.png";